const NAMESPACE = "CREDIT_HISTORY";
const actionType = type => `${NAMESPACE}_${type}`;

export const creditHistoryConstants = {
	SEND_CREDIT_HISTORY_REQUEST: actionType("SEND_CREDIT_HISTORY_REQUEST"),
	SEND_CREDIT_HISTORY_SUCCESS: actionType("SEND_CREDIT_HISTORY_SUCCESS"),
	SEND_CREDIT_HISTORY_ERROR: actionType("SEND_CREDIT_HISTORY_ERROR"),

	SET_BANKS: actionType("SET_BANKS"),
};
